import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';

import store from '@/store';
import { conduitApi } from '../api';
import { Meta, Response, ResponseSingle, Query, ULID } from '../models';
import { Customer, CustomerFormEdit, CustomerActivateForm } from '../models/customer';

@Module({
	namespaced: true,
	name: 'customer',
	store,
	dynamic: true
})
class CustomerModule extends VuexModule {
	customer: Customer = {} as any;

	customers: Customer[] = [];

	meta: Meta = {};

	@Mutation
	setAll(customers: Response): void {
		this.customers = customers.data as Customer[];
		this.meta = customers.meta as Meta;
	}

	@Mutation
	set(customer: ResponseSingle): void {
		this.customer = customer.data as Customer;
	}

	@Action({ commit: 'set', rawError: true })
	async get(query: Query): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/customers/${query.customerID}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async update(customer: CustomerFormEdit): Promise<void> {
		try {
			await conduitApi.put(`/customers/${customer.id}`, JSON.stringify(customer));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async getSubscription(query: Query): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/customers/${query.customerID}/subscription`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async getUsage(query: Query): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/customers/${query.customerID}/status`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async getProgress(): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/register/progress`);
			return response.data.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async activate(a: CustomerActivateForm): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.post(`/register/activate`, JSON.stringify(a));
			return response.data.data;
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(CustomerModule);
